module.exports = __webpack_public_path__ + "img/BANDEAU_FICHES_INDIVIDUS.40e92cff.svg";